import { render, staticRenderFns } from "./tg3.vue?vue&type=template&id=cd4bae94&scoped=true&"
import script from "./tg3.vue?vue&type=script&lang=js&"
export * from "./tg3.vue?vue&type=script&lang=js&"
import style0 from "./tg3.vue?vue&type=style&index=0&id=cd4bae94&prod&lang=css&"
import style1 from "./tg3.vue?vue&type=style&index=1&id=cd4bae94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4bae94",
  null
  
)

export default component.exports